import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getIsPresetsListFetched, getPresetsListSelector } from '../../modules/selectors';
import { Input } from 'reactstrap';
import { fetchPresetsAction } from '../../modules/actions';
import { getTranslationKey } from '../../modules/utils';
import { SwitchItem } from '../../components';

let setDefaultPreset = false;

const switchDirection = 'row-reverse';
const switchMargin = '7px 0';

interface FaceRecognition {
  enabled: boolean;
}

interface GalleryPreset {
  _id: string;
  name: string;
  default?: boolean;
  faceRecognition?: FaceRecognition;
  _userbrand?: string;
  _scrappbookGalleryTemplate?: string;
  [key: string]: any;
}

interface GalleryPresetSelectProps {
  selectedPresetId?: string;
  onChange: (preset: GalleryPreset) => void;
  onFaceDataChange: (faceRecognition: FaceRecognition) => void;
  faceRecognition: FaceRecognition;
}

const GalleryPresetSelect: React.FC<GalleryPresetSelectProps> = ({
  selectedPresetId,
  onChange,
  onFaceDataChange,
  faceRecognition
}) => {
  const dispatch = useDispatch();
  const galleryPresets = useSelector(getPresetsListSelector) as GalleryPreset[];
  const isFetched = useSelector(getIsPresetsListFetched) as boolean;

  useEffect(() => {
    if (!isFetched) {
      dispatch(fetchPresetsAction());
    }
  }, [isFetched, dispatch]);

  if (galleryPresets.length && !setDefaultPreset) {
    const defaultGalleryPreset = galleryPresets.find((p) => p.default) || galleryPresets[0];
    if (defaultGalleryPreset) {
      setDefaultPreset = true;
      onChange(defaultGalleryPreset);
    }
  }

  // const currentPreset = galleryPresets.find((p) => p._id === selectedPresetId);

  return (
    <>
      <Input
        type="select"
        onChange={({ target: { value } }) =>
          galleryPresets.length && onChange(galleryPresets.find((p) => p._id === value)!)
        }
        value={selectedPresetId || 'standard'}
        className="pt-gallery-preset-select-preset-gallery-creation"
      >
        {(!galleryPresets || galleryPresets.length === 0) && (
          <option value="standard">{getTranslationKey('galleryPresets.notFound')}</option>
        )}
        {galleryPresets &&
          galleryPresets.map((preset) => (
            <option key={preset._id} value={preset._id}>
              {preset.name}
            </option>
          ))}
      </Input>
      <SwitchItem
        value={faceRecognition?.enabled}
        changeCallback={(enabled: boolean) => {
          onFaceDataChange({ enabled });
        }}
        label={getTranslationKey('collectionSettings.shouldCollectFaceData')}
        direction={switchDirection}
        margin={switchMargin}
        tooltipText={getTranslationKey('faceRecognition.dataProcessingInfo')}
        isIconTooltip
        withTooltip
      />
    </>
  );
};

export default GalleryPresetSelect;
